import {
    USERS_LOADING,
    USERS_LOADED,
    USERS_SEARCH,
    USERS_CREATED,
    USERS_DELETED,
    USERS_EDITED,
    USERS_FAILED,
    USERS_ACTIVITIES_LOADED,
    USERS_ACTIVITIES_FAILED,
    USERS_ACTIVITIES_LOADING,
} from '../types';

import {
    created,
    editedUpdate,
    deleteFromState,
} from '../../helpers/reduxUtils';

const initialState = {
    loading: false,
    allUsers: [],
    activities: [],
    searchResults: [],
    success: false,
};

export default function(state = initialState, action) {
    switch (action.type) {
        case USERS_ACTIVITIES_LOADING:
        case USERS_LOADING:
            return {
                ...state,
                loading: true,
                success: false,
                activities: [],
            };
        case USERS_LOADED:
            return {
                ...state,
                loading: false,
                success: false,
                allUsers: action.payload,
            };
        case USERS_SEARCH:
            return {
                ...state,
                loading: false,
                success: false,
                searchResults: action.payload,
            };
        case USERS_CREATED:
            return {
                ...state,
                loading: false,
                success: true,
                allUsers: created(state.allUsers, action.payload),
            };
        case USERS_EDITED:
            return {
                ...state,
                loading: false,
                success: true,
                allUsers: editedUpdate(state.allUsers, action.payload),
            };
        case USERS_DELETED:
            return {
                ...state,
                loading: false,
                success: true,
                allUsers: deleteFromState(state.allUsers, action.payload),
            };
        case USERS_ACTIVITIES_LOADED:
            return {
                ...state,
                loading: false,
                activities: action.payload,
            };
        case USERS_ACTIVITIES_FAILED:
            return {
                ...state,
                loading: false,
                activities: [],
            };
        case USERS_FAILED:
            return {
                ...state,
                loading: false,
                success: false,
            };
        default:
            return state;
    }
}